import { useIsRestoring, useQuery } from "@tanstack/react-query";
import { ClassesApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createOpenApiConfiguration } from "@/lib/utils";

export const useClassesGet = () => {
  const isRestoring = useIsRestoring();
  const { data, isError, isLoading, isSuccess, isPending, isFetching, refetch } = useQuery({
    queryKey: [QueryKeys.Classes],
    queryFn: () => {
      // Create API instance without authentication for public access
      const service = new ClassesApi(createOpenApiConfiguration());
      return service.apiClassesScrollGet({
        page: 1,
        pageSize: 1000,
      });
    },
    enabled: !isRestoring,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    isFetching,
    refetch,
  };
};
